module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/dino-a491ca9f5371a00da9350d2bbc62893a.png";